import React, { useEffect, useState } from "react";
import { configs, downloadDoc, downloadBlobFile, formatCurrency, formatNumber } from "../../../assets/Config";
import { useLogin } from "../../../services/contexts/AdminLoginContext";
import LeftBarPage from "../../includes/dashboard/LeftBarPage";
import TopBarPage from "../../includes/dashboard/TopBarPage";
import "../../../assets/styles/BuyOrder.css"
import ToastPage from "../../includes/ToastPage";
import { useHistory } from "react-router";
import { sellReconcileDepLogs, sellReconcileFile, getExecutionLogs, getExecutionOutputFile } from "../../../services/apis/shareManagement/SellOrdersApi";
import { Modal } from "@material-ui/core";
import { DataGrid, GridToolbar } from "@material-ui/data-grid";

export default function SellReconcile() {

    const { setCurrModule, setShowSuccess, allowedFunc, token, logout, setLoginError } = useLogin()

    const history = useHistory();

    const [orderFile, setOrderFile] = useState("");
    const [hdfcFile, setHdfcFile] = useState("");
    const [nsdlFile, setNsdlFile] = useState("");
    const [cdslFile, setCdslFile] = useState("");
    const [showErrorModal, setShowErrorModal] = useState(false)
    const [errorDetail, setErrorDetail] = useState("")
    const [fileError, setFileError] = useState("")
    const [depLogs, setDepLogs] = useState("");
    const [executionLogs, setExecutionLogs] = useState([]);
    const [executionLogsLoading, setExecutionLogsLoading] = useState(false);
    const [executionLogsFetched, setExecutionLogsFetched] = useState(false);


    useEffect(() => {
        try {
            if (allowedFunc.includes(configs.functionList["sell_automation:sell_automation"])) {
                setCurrModule(configs.modules.sellReconcile)
            } else {
                return history.goBack()
            }
        } catch (error) {
            console.error(error)
        }
    }, [])

    const handleClose = () => {
        setShowErrorModal(false);
    };


    // get file contents through file chooser
    function uploadFile(file, type) {
        try {
            if (file.type === ".xls" || file.type === ".csv" || file.type === "text/csv" || file.type === "xlsx" || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type === "application/vnd.ms-excel") {
                if (type === "ORDER") {
                    setOrderFile(file)
                } else if (type === "HDFC") {
                    setHdfcFile(file)
                } else if (type === "NSDL") {
                    setNsdlFile(file)
                } else if (type === "CDSL") {
                    setCdslFile(file)
                }
                setFileError("")
            } else {
                alert("Only excel/csv files are allowed.")
            }
        } catch (error) {
            console.error(error)
        }
    }

    // upload csv to server
    async function uploadFileToServer() {
        try {
            document.getElementById("fileBtn").classList.toggle("d-none")
            document.getElementById("fileBtnLoader").classList.toggle("d-none")
            if (!hdfcFile && !nsdlFile && !cdslFile) {
                setFileError("Please select all the file to proceed.")
            } else {
                let response = await sellReconcileFile(token, hdfcFile, nsdlFile, cdslFile);
                if (response && response.status === 200) {
                    setFileError("")
                    setHdfcFile("")
                    setCdslFile("")
                    setNsdlFile("")
                    setOrderFile("")
                    setErrorDetail("")
                    setShowSuccess(true)
                    downloadDoc("Sell_Reconcile_Report", response.data, true)
                } else if (response && response.status === 401) {
                    logout();
                    setLoginError(configs.unauthorizedErrorMessage);
                }
                else if (response && response.status === 406) {
                    setFileError("Click to view error details.");
                    setErrorDetail(response.data.error);
                }
                else {
                    setFileError(response.data.error)
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            document.getElementById("fileBtn").classList.toggle("d-none")
            document.getElementById("fileBtnLoader").classList.toggle("d-none")
        }
    }

    // get sell reconcile depository logs
    async function getSellRecDepLogs() {
        try {
            document.getElementById("getDeplogBtn").classList.toggle("d-none")
            document.getElementById("getDeplogBtnLoader").classList.toggle("d-none")

            let response = await sellReconcileDepLogs(token);
            if (response && response.status === 200) {
                setDepLogs(response.data && response.data.length > 0 ? response.data : "No logs found.");
            } else if (response && response.status === 401) {
                logout();
                setLoginError(configs.unauthorizedErrorMessage);
            }
            else {
                setFileError(response.data.error)
            }
        } catch (error) {
            console.error(error);
        } finally {
            document.getElementById("getDeplogBtn").classList.toggle("d-none")
            document.getElementById("getDeplogBtnLoader").classList.toggle("d-none")
        }
    }

    // get execution logs
    async function fetchExecutionLogs() {
        try {
            setExecutionLogsLoading(true);
            setExecutionLogs([]);
            setExecutionLogsFetched(false);
            let response = await getExecutionLogs(token);
            if (response && response.status === 200) {
                const list = Array.isArray(response.data) ? response.data : [];
                setExecutionLogs(list);
            } else if (response && response.status === 401) {
                logout();
                setLoginError(configs.unauthorizedErrorMessage);
            }
            setExecutionLogsFetched(true);
        } catch (error) {
            console.error(error);
            setExecutionLogsFetched(true);
        } finally {
            setExecutionLogsLoading(false);
        }
    }

    // download execution output file (Excel)
    async function downloadExecutionOutput(id, filename) {
        try {
            let response = await getExecutionOutputFile(token, id);
            if (response && response.status === 200 && response.data instanceof Blob) {
                downloadDoc(`execution-output-${id}`, response.data, true)
            } else if (response && response.status === 401) {
                logout();
                setLoginError(configs.unauthorizedErrorMessage);
            }
        } catch (error) {
            console.error(error);
        }
    }

    const executionLogColumns = [
        { field: "id", headerName: "ID", minWidth: 80, flex: 0.3 },
        { field: "datetime", headerName: "Date & Time", minWidth: 160, flex: 0.5, cellClassName: "break-text" },
        { field: "filename", headerName: "Filename", minWidth: 200, flex: 0.6, cellClassName: "break-text" },
        {
            field: "download",
            headerName: "Download",
            minWidth: 100,
            flex: 0.3,
            filterable: false,
            renderCell: (params) => {
                return <a
                    href="#"
                    className="custom-link text-primary"
                    onClick={(e) => {
                        e.preventDefault();
                        downloadExecutionOutput(params.row.id, params.row.filename);
                    }}
                >
                    Download
                </a>
            },
        },
    ];

    const columns = [{ field: "id", headerName: "Log ID", minWidth: 100, flex: 0.5, filterable: false },
    { field: "created_at", headerName: "Creation Time", minWidth: 150, flex: 0.5, cellClassName: "break-text" },
    { field: "isin", headerName: "ISIN", minWidth: 100, flex: 0.4, cellClassName: "break-text" },
    { field: "description", headerName: "Description", minWidth: 100, flex: 0.4, cellClassName: "break-text" },
    {
        field: "credit", headerName: "Credit", minWidth: 100, flex: 0.3, cellClassName: "break-text", renderCell: (params) => {
            return formatCurrency(params.row.credit)
        }, valueGetter: (value) => value.row.credit
    },
    {
        field: "debit", headerName: "Debit", minWidth: 100, flex: 0.3, cellClassName: "break-text", renderCell: (params) => {
            return formatCurrency(params.row.debit)
        }, valueGetter: (value) => value.row.debit
    },
    { field: "transaction_id", headerName: "Transaction ID", minWidth: 100, flex: 0.5 },
    { field: "dp", headerName: "DP ID", minWidth: 100, flex: 0.5 },
    { field: "client_id", headerName: "Client ID", minWidth: 100, flex: 0.5 },
    { field: "order_id", headerName: "Order ID", minWidth: 100, flex: 0.5 }
    ]

    return (
        <>
            <TopBarPage />
            <div style={{ display: "flex" }}>
                <LeftBarPage />
                <div id="mpOrder" className="smPO-container">
                    <div className="col-12 text-left">
                        <p className="h3 text-custom-greyDark mb-0">Sell Order Reconcile</p>
                    </div>
                    <div className="smPOI-container">
                        <form id="fileForm">
                            <div className="row m-0 p-0">
                                {/* <div className="col-md-4 col-12">
                                    <div className="form-group mt-5">
                                        <p className="h6 text-custom-grey">Upload Order file</p>
                                        <div className="file-border rounded py-4" onDragOver={(e) => {
                                            e.preventDefault();
                                        }} onDrop={(e) => {
                                            uploadFile(e.dataTransfer.files[0], "ORDER")
                                            e.preventDefault();
                                        }}>
                                            <i className="fas fa-file-upload f-22"></i>
                                            <p className="pb-0 mb-0 f-12">
                                                Drag your file or &nbsp;
                                                <input type="file" id="upload_order_file" required hidden accept=".csv, text/csv, .xls, xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={(e) => {
                                                    uploadFile(e.target.files[0], "ORDER")
                                                }} />
                                                <label htmlFor="upload_order_file" className="mb-0 pb-0">Click here</label>
                                                &nbsp; to choose <br /> Upload: <span className="text-theme">{orderFile.name}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div> */}
                                <div className="col-md-4 col-12">
                                    <div className="form-group mt-5">
                                        <p className="h6 text-custom-grey">Upload HDFC file</p>
                                        <div className="file-border rounded py-4" onDragOver={(e) => {
                                            e.preventDefault();
                                        }} onDrop={(e) => {
                                            uploadFile(e.dataTransfer.files[0], "HDFC")
                                            e.preventDefault();
                                        }}>
                                            <i className="fas fa-file-upload f-22"></i>
                                            <p className="pb-0 mb-0 f-12">
                                                Drag your file or &nbsp;
                                                <input type="file" id="upload_hdfc_file" required hidden accept=".csv, text/csv, .xls, xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={(e) => {
                                                    uploadFile(e.target.files[0], "HDFC")
                                                }} />
                                                <label htmlFor="upload_hdfc_file" className="mb-0 pb-0">Click here</label>
                                                &nbsp; to choose <br /> Upload: <span className="text-theme">{hdfcFile.name}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-12">
                                    <div className="form-group mt-5">
                                        <p className="h6 text-custom-grey">Upload NSDL file</p>
                                        <div className="file-border rounded py-4" onDragOver={(e) => {
                                            e.preventDefault();
                                        }} onDrop={(e) => {
                                            uploadFile(e.dataTransfer.files[0], "NSDL")
                                            e.preventDefault();
                                        }}>
                                            <i className="fas fa-file-upload f-22"></i>
                                            <p className="pb-0 mb-0 f-12">
                                                Drag your file or &nbsp;
                                                <input type="file" id="upload_nsdl_file" required hidden accept=".csv, text/csv, .xls, xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={(e) => {
                                                    uploadFile(e.target.files[0], "NSDL")
                                                }} />
                                                <label htmlFor="upload_nsdl_file" className="mb-0 pb-0">Click here</label>
                                                &nbsp; to choose <br /> Upload: <span className="text-theme">{nsdlFile.name}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-12">
                                    <div className="form-group mt-5">
                                        <p className="h6 text-custom-grey">Upload CDSL file</p>
                                        <div className="file-border rounded py-4" onDragOver={(e) => {
                                            e.preventDefault();
                                        }} onDrop={(e) => {
                                            uploadFile(e.dataTransfer.files[0], "CDSL")
                                            e.preventDefault();
                                        }}>
                                            <i className="fas fa-file-upload f-22"></i>
                                            <p className="pb-0 mb-0 f-12">
                                                Drag your file or &nbsp;
                                                <input type="file" id="upload_cdsl_file" required hidden accept=".csv, text/csv, .xls, xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={(e) => {
                                                    uploadFile(e.target.files[0], "CDSL")
                                                }} />
                                                <label htmlFor="upload_cdsl_file" className="mb-0 pb-0">Click here</label>
                                                &nbsp; to choose <br /> Upload: <span className="text-theme">{cdslFile.name}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-check p-0">
                                {errorDetail ? <p className="text-danger curPoint" id="inventoryError" onClick={(e) => {
                                    e.preventDefault()
                                    setShowErrorModal(true)
                                }}>{fileError}</p> : <p className="text-danger" id="inventoryError">{fileError}</p>}
                            </div>
                            <div className="d-flex justify-content-center">
                                <div className="text-center mr-1">
                                    <a id="fileBtn" href="#" className="btn btn-primary f-12" onClick={(e) => {
                                        e.preventDefault()
                                        uploadFileToServer()
                                        document.getElementById("fileForm").reset();
                                    }}><i className="fas fa-upload mr-2"></i>Start Reconcillation</a>
                                    <div id="fileBtnLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                                </div>
                                <div className="text-center ml-1">
                                    <a id="getDeplogBtn" href="#" className="btn btn-primary f-12" onClick={(e) => {
                                        e.preventDefault()
                                        getSellRecDepLogs()
                                    }}><i className="fas fa-download mr-2"></i>Get depository logs</a>
                                    <div id="getDeplogBtnLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                                </div>
                                <div className="text-center ml-1">
                                    <a href="#" className="btn btn-primary f-12" onClick={(e) => {
                                        e.preventDefault();
                                        fetchExecutionLogs();
                                    }} disabled={executionLogsLoading}>
                                        <i className="fas fa-list mr-2"></i>Get execution logs
                                    </a>
                                </div>
                            </div>
                        </form>
                        {executionLogs && Array.isArray(executionLogs) && executionLogs.length > 0 ?
                            <><p className="h6 text-custom-grey mt-4">Execution Logs</p>
                                <DataGrid
                                    rows={executionLogs}
                                    columns={executionLogColumns}
                                    resizable={true}
                                    // pageSize={rowsDisplay}
                                    rowHeight={40}
                                    headerHeight={30}
                                    pagination
                                    components={{
                                        Toolbar: GridToolbar,
                                    }}
                                />
                            </>
                            : executionLogs && typeof executionLogs === "string" ?
                                <div className="text-center text-danger mt-5">
                                    <p className="h6">{executionLogs}</p>
                                </div>
                                : null}
                        {depLogs && Array.isArray(depLogs) && depLogs.length > 0 ?
                            <><p className="h6 text-custom-grey mt-4">Depository Logs</p>
                                <DataGrid
                                    rows={depLogs}
                                    columns={columns}
                                    resizable={true}
                                    // pageSize={rowsDisplay}
                                    rowHeight={40}
                                    headerHeight={30}
                                    pagination
                                    components={{
                                        Toolbar: GridToolbar,
                                    }}
                                // onPageChange={(currenIndex) => {
                                //     if ((currenIndex + 1) === Math.ceil(kycRequestersList.length / rowsDisplay)) {
                                //         setPage(page + 1);
                                //     }
                                // }}
                                // onPageSizeChange={(rowsBeingDisplayed) => {
                                //     setRowsDisplay(rowsBeingDisplayed);
                                // }}
                                />
                            </>
                            : depLogs && typeof depLogs === "string" ?
                                <div className="text-center text-danger mt-5">
                                    <p className="h6">{depLogs}</p>
                                </div>
                                : null}
                    </div >
                </div>
            </div>
            <ToastPage />
            {/* --------------------------------------------Error Detail Modal-------------------------------------------------------------------- */}
            <Modal open={showErrorModal} onClose={handleClose}>
                <div className="modal-fade" id="KYCSubmitModal" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header border-0">
                                <h5>Error Detail</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body py-3" style={{ overflowY: "auto", height: "500px" }}>
                                <p className="text-danger">Following errors were found while trying to upload data:</p>
                                <ol>
                                    {Object.keys(errorDetail).map((element, key) => {
                                        if (Array.isArray(errorDetail[element]) && errorDetail[element].length > 0) {
                                            return <li key={`out` + key}>{element}
                                                <ol type='i'>
                                                    {errorDetail[element].map((inner, key) => {
                                                        return <li key={`inner` + key}>{inner}</li>
                                                    })}
                                                </ol>
                                            </li>
                                        } else if (!Array.isArray(errorDetail[element])) {
                                            return <li key={`out` + key}>{element}
                                                <ol type='i'>
                                                    {Object.keys(errorDetail[element]).map((inner, key) => {
                                                        return <li key={`inner` + key}>{inner}
                                                            <ol type='a'>
                                                                {errorDetail[element][inner].map((error, key) => {
                                                                    return <li key={`err` + key}>{error}</li>
                                                                })}
                                                            </ol>
                                                        </li>
                                                    })}
                                                </ol>
                                            </li>
                                        }

                                    })}
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}